export default "__VITE_ASSET__Dt_NYAfc__"